import { MobicloudResponse } from 'app/global/class/mobicloud-response';

export const extractIFPResponse = <T>(response: MobicloudResponse<T>): T => {
    if (!response || !response.output || !response.output) {
        console.error('Response not valid: ', response);
        return null;
    }
    return response.output;
};
